<template>
    <material-card
        style="position: relative;"        
        progress-color="white"
        icon="$vuetify.icons.universe"
        color="primary"
        :loading="loading"
    >
        <template #title>
            <v-card 
                flat              
                style="position: sticky; top: 0;align-self: flex-start"
            >
                <h1
                    class="infinity-text"
                    style="font-weight: 400"
                    v-html="universe.data.name"
                />
                <h2 
                    style="font-weight: 300"
                    v-html="universe.data.title || '&nbsp;'"
                />
            <v-card-actions
                class="pr-12 pt-5"
            >
                <!-- <v-spacer /> -->
                <universe-edit-button :universe="universe.data.name" />
            </v-card-actions>
            </v-card>
        </template>
        <v-container>
            <v-card 
                flat
                class="description"
                v-html="description(universe.data.description)"
            />
        </v-container>
        <v-container>
            <v-row>
                <v-col 
                    v-for="app in apps.items"
                    :key="app.id"
                    cols="6"
                > 
                    <material-card
                        style="position: relative;"        
                        progress-color="white"
                        icon="$vuetify.icons.app"
                        color="primary"
                        hover                        
                    >
                        <template #title>
                            <v-card 
                                flat              
                                style="position: sticky; top: 0;align-self: flex-start"
                            >
                                <h1
                                    class="infinity-text"
                                    style="font-weight: 400"
                                    v-html="app.data.name"
                                />
                                <h2 
                                    style="font-weight: 300"
                                    v-html="app.data.subtitle || '&nbsp;'"
                                />
                                <v-card-actions
                                    class="pr-12 pt-5"
                                >                            
                                </v-card-actions>
                            </v-card>
                        </template>
                        <v-card-text 
                            style="color: rgb(51, 51, 51)"
                            v-html="description(app.data.description || '')" 
                        />
                        <v-card-actions>
                            <v-spacer />
                            <v-btn
                                :href="link(app)"
                                x-large
                                block
                                depressed
                                dark
                                color="orange"
                            >
                                <v-icon 
                                    left 
                                >mdi-link</v-icon>
                                Visit application
                            </v-btn>
                        </v-card-actions>
                    </material-card>                    
                </v-col>
            </v-row>
        </v-container>
    </material-card>       
</template>
<script>
import { mapActions } from 'pinia'
import { useAppStore } from '@/store/app-store'
import { marked } from 'marked'
import UniverseEditButton from '@/layouts/Universe/widgets/EditButton'

export default {
    name: 'UniverseHub',
    components: {
        UniverseEditButton,
    },
    props: {
        universe: Object,
    },
    data: () => {
        return {
            apps: { items: [] },           
        }
    },
    computed: {
    },
    async mounted () {
        this.apps = await this.loadApps(this.universe.id)
    },
    methods: {
        ...mapActions(useAppStore, ['loadApps']),
        description (md) {
            return marked(md || '')
        },
        link (app) {
            const host = window.location.host
            return `https://${app.name}-${app.universe}.${host}`
        },
    },
}
</script>
